import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { ReactElement } from 'react';
import { clientSideFeatureToggles } from '../../../../../configuration/featureToggle/clientSideFeatureToggles';
import { useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderCategory } from '../../../reducers/serviceOrdersSlice';
import { ServiceCategory } from '../commonServiceOrder.types';
import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { ServiceOrderCategoriesSelection } from './ServiceOrderCategoriesSelection';
import { ServiceOrderFilterModal } from './ServiceOrderFilterModal';
import { ServiceOrderToolbarSearch } from './ServiceOrderToolbarSearch';
import { TableViewOptions } from '../../../sharedComponents/TableViewOptions';
import { TableColumnSettings } from '../../../sharedComponents/table/TableColumnSettings';

type ServiceOrderTableToolbarProps = {
    statusFilter: ReactElement;
    exportModal?: ReactElement;
};

export const ServiceOrderTableToolbar = ({ statusFilter, exportModal }: ServiceOrderTableToolbarProps) => {
    const serviceCategory = useAppSelector(getServiceOrderCategory);
    const showBulkButton = clientSideFeatureToggles.serviceOrderBulk && serviceCategory === ServiceCategory.CURRENT;
    return (
        <TableToolbar>
            <div className="table-toolbar-container">
                <div className="table-toolbar-group-left">
                    <div className="table-toolbar-column">
                        <div className="btn-toolbar table-btn-toolbar">
                            <ServiceOrderCategoriesSelection />
                        </div>
                    </div>
                </div>
                <div className="table-toolbar-group-right">
                    {showBulkButton && (
                        <div className="table-toolbar-column table-toolbar-column-spacer">
                            <Button disabled bsStyle={Button.PRIMARY}>
                                <FormattedMessage
                                    id="outboundOrderBook.serviceOrder.toolbar.bulkUpdate"
                                    values={{ count: 0 }}
                                />
                            </Button>
                        </div>
                    )}
                    <div className="table-toolbar-column min-width-300">{statusFilter}</div>
                    <div className="table-toolbar-column">
                        <ServiceOrderFilterModal />
                    </div>
                    <div className="table-toolbar-column">
                        <ServiceOrderToolbarSearch />
                    </div>
                    {exportModal && <div className="table-toolbar-column">{exportModal}</div>}
                    <div className="table-toolbar-column">
                        <TableViewOptions />
                    </div>
                    <div className="table-toolbar-column">
                        <TableColumnSettings />
                    </div>
                </div>
            </div>
        </TableToolbar>
    );
};
